import { providerState, sessionState } from "@/state";
import StepId from "@/model/progress/StepId";

const providerKey = "lendingclub_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "lendingclubResumeAfterFullApply",
            path: `/providers/${providerKey}/resume/after-full-apply`,
            meta: { stepper: false },
            redirect: `/providers/${providerKey}/offerReviewNext`,
        },
        {
            name: "lendingclubResume",
            path: `/providers/${providerKey}/resume`,
            meta: { step: StepId.APPLICANT_INFO, stepper: false },
            component: () => import(/* webpackChunkName: "lendingclub" */ "@/views/provider/lendingclub/LendingClubResumeView"),
        },
        {
            name: "lendingclubPrequalifyOfferReviewNext",
            path: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            redirect: `/providers/${providerKey}/checkCalifornia`,
        },
        {
            name: "lendingclubOfferReviewNext",
            path: `/providers/${providerKey}/offerReviewNext`,
            redirect: `/providers/${providerKey}/terms`,
        },
        {
            name: "lendingclubPrequalifyTerms",
            path: `/providers/${providerKey}/terms`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(/* webpackChunkName: "lendingclub" */ "@/views/provider/lendingclub/LendingClubIframeView"),
        },
        {
            name: "lendingclubTruePending",
            path: `/providers/${providerKey}/true-pending`,
            meta: { step: StepId.COMPLETE, stepper: false },
            component: () => import("@/views/apply/PendingView"),
        },
        {
            name: "lendingclubApproved",
            path: `/providers/${providerKey}/approved`,
            meta: { step: StepId.COMPLETE },
            extends: "approved",
            component: () => import(/* webpackChunkName:"lendingclub" */ "@/views/provider/lendingclub/LendingClubApprovedView"),
        },
        {
            name: "lendingclubPending",
            path: `/providers/${providerKey}/pending`,
            meta: { step: StepId.COMPLETE, stepper: false },
            redirect: () => {
                let applyResponse = providerState.getApplyResponse(sessionState.providerKey)
                if (applyResponse && applyResponse.pendingReasons?.length && applyResponse?.pendingReasons?.includes("verify_email")) {
                    return `/providers/${providerKey}/approved`
                }
                return `/providers/${providerKey}/true-pending`
            },
        },
        {
            name: "lendingclubExpired",
            path: `/providers/${providerKey}/expired`,
            meta: { step: StepId.COMPLETE },
            component: () => import(/* webpackChunkName:"lendingclub" */ "@/views/provider/lendingclub/LendingClubExpiredView"),
        },
        {
            name: "lendingclubResumeFromPaymentPlanReview",
            path: `/providers/${providerKey}/resume/from-payment-plan-review`,
            redirect: `/providers/${providerKey}/modes/prequalify/offerReviewNext`
        },

    ],
}
